import { Trans, useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import classnames from 'classnames';
import Checkbox from '@/components/UI/Checkbox';
import { MyLink } from '@/components/MyLink';
import { APP_LINKS } from '@/helpers/links';
import r from '@/kit/RoundButton/button.module.scss';
import s from './index.module.scss';

export const ConfirmBlock = ({ label, disabled }) => {
  const { t } = useTranslation('fundraising');
  const { values, touched, isSubmitting, errors, handleSubmit, setFieldValue } = useFormikContext();
  return (
    <div className={s.wrapper}>
      <div className={s.checkboxes}>
        <Checkbox
          name="has_accepted_terms"
          isChecked={values.has_accepted_terms}
          onChange={() => setFieldValue('has_accepted_terms', !values.has_accepted_terms)}
          error={touched.has_accepted_terms && errors.has_accepted_terms}
          render={() => (
            <span
              className={classnames(
                'f-14',
                touched.has_accepted_terms && errors.has_accepted_terms && s.error,
              )}
            >
              <Trans
                ns="fundraising"
                i18nKey="confirm_block.agree_terms"
                components={{
                  LinkTerms: <MyLink href={APP_LINKS.docTermsOfUse} underline isExternal />,
                  LinkAssigmentAgreement: (
                    <MyLink href={APP_LINKS.docAssignmentAgreement} underline isExternal />
                  ),
                  LinkSuretyAgreement: (
                    <MyLink href={APP_LINKS.suretyAgreement} underline isExternal />
                  ),
                }}
              />
            </span>
          )}
        />
      </div>
      <div className={s.buttons}>
        <button
          type="submit"
          disabled={disabled || isSubmitting}
          className={classnames(r.black_large, r.shrink_height)}
          onSubmit={handleSubmit}
        >
          {label || t('confirm_block.confirm_participation')}
        </button>
      </div>
    </div>
  );
};
